{
    "mpid-list-quick-search-fields": [
        {
            "label": "MPID", "columnname": "IMID", "placeholder": "MPID",
            "width": "", "datatype": "String", "isLarge": false
        },
        {
            "label": "Firm Name", "columnname": "firmName", "placeholder": "Firm Name",
            "width": "", "datatype": "String", "isLarge": true
        },
        {
            "label": "CRDID", "columnname": "CRDID", "placeholder": "CRDID",
            "width": "", "datatype": "String", "isLarge": true
        }
    ],
    "mpid-list-grid-columns": [
        {
            "display": "false",
            "ui_columnname": "Row ID",
            "db_columnname": "RowNo",
            "datatype": "String",
            "mappingkey": "RowNo",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CRDID",
            "db_columnname": "CRDID",
            "datatype": "String",
            "mappingkey": "CRDID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "FINRA Member",
            "db_columnname": "FINRAMember",
            "datatype": "String",
            "mappingkey": "FINRAMember",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Firm Name",
            "db_columnname": "firmName",
            "datatype": "String",
            "mappingkey": "firmName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "true",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "IMID",
            "db_columnname": "IMID",
            "datatype": "String",
            "mappingkey": "IMID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "true",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Exchange ID",
            "db_columnname": "exchangeID",
            "datatype": "String",
            "mappingkey": "exchangeID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "ATS Flag",
            "db_columnname": "ATSFlag",
            "datatype": "String",
            "mappingkey": "ATSFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Default IMID",
            "db_columnname": "defaultIMID",
            "datatype": "String",
            "mappingkey": "defaultIMID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Report Date",
            "db_columnname": "reportDate",
            "datatype": "String",
            "mappingkey": "reportDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Effective Date",
            "db_columnname": "effectiveDate",
            "datatype": "String",
            "mappingkey": "effectiveDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Expiry Date",
            "db_columnname": "expiryDate",
            "datatype": "String",
            "mappingkey": "expiryDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Update User",
            "db_columnname": "updateUser",
            "datatype": "String",
            "mappingkey": "updateUser",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        }
    ]
}